<proffeo-ui-dialog [title]="'cooperations.modals.select-projects-title' | translate">
  <div class="flex w-full flex-col gap-2">
    @if (!projects().length) {
      <p class="text-sm text-proffeo-muted">{{ 'cooperations.no-projects-available-to-add' | translate }}</p>
    } @else {
      <p class="text-sm">{{ 'cooperations.modals.select-projects-desc' | translate }}</p>
      <div class="flex max-h-80 flex-col gap-1 overflow-y-auto rounded border border-proffeo-overlay-subtle p-2">
        @for (project of projects(); track project.id) {
          <label
            for="project-{{ project.id }}"
            class="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 hover:bg-proffeo-surface-muted"
          >
            <mat-checkbox
              (change)="toggle(project.id, $event)"
              [checked]="isSelected(project.id)"
            ></mat-checkbox>
            <span class="text-sm text-proffeo-text">{{ project.name ?? '—' }}</span>
          </label>
        }
      </div>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      [text]="'common.cancel' | translate"
      variant="secondary"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="!canSave()"
      [text]="'cooperations.add-selected-projects' | translate"
      variant="accent"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
